export class AutopilotDevice {
    id?: string;
    deploymentProfileAssignmentStatus?: string;
    deploymentProfileAssignmentDetailedStatus?: string;
    deploymentProfileAssignedDateTime?: string;
    groupTag?: string;
    purchaseOrderIdentifier?: string;
    serialNumber?: string;
    productKey?: string;
    manufacturer?: string;
    model?: string;
    enrollmentState?: string;
    lastContactedDateTime?: string;
    addressableUserName?: string;
    userPrincipalName?: string;
    resourceName?: string;
    skuNumber?: string;
    systemFamily?: string;
    azureActiveDirectoryDeviceId?: string;
    azureAdDeviceId?: string;
    managedDeviceId?: string;
    displayName?: string;
    deviceAccountUpn?: string;
    deviceAccountPassword?: string | null;
    deviceFriendlyName?: string | null;
    remediationState?: string;
    remediationStateLastModifiedDateTime?: string;
    userlessEnrollmentStatus?: string;

    constructor(data?: Partial<AutopilotDevice>) {
        Object.assign(this, data);
    }
}